import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./rules-editor-trigger-section.module.scss";
import RulesEditorSection from "./rules-editor-section";
import VelavuInput from "../../../elements/velavu-input";
import VelavuSelect from "../../../elements/velavu-select";

export interface RulesEditorConditionSectionProps {
	condition: string;
	onChangeCondition: (condition: string) => void;

	priority: number;
	onChangePriority: (priority: number) => void;
}

/**
 * A section in the rules editor that asks for the trigger settings of a rule
 */
export default function RulesEditorTriggerSection(
	props: RulesEditorConditionSectionProps,
) {
	const { t } = useTranslation();

	return (
		<RulesEditorSection className={styles.container}>
			<VelavuInput
				titleText={t("rules.editor.condition")}
				value={props.condition}
				onChange={props.onChangeCondition}
				placeholder="asset.category == HAZARDOUS_MATERIALS AND geofence_ids CONTAINS fA2SLW21tr"
				inputClassName="id16"
				fullWidth
				multiline
				autoResize
				spellCheck={false}
				rows={3}
			/>

			<VelavuSelect
				style={{ width: 66 }}
				fullWidth
				titleText={t("rules.editor.priority")}
				value={props.priority}
				onChange={props.onChangePriority}
			>
				{Array.from({ length: 10 }, (_, idx) => (
					<option key={idx} value={idx}>
						{idx}
					</option>
				))}
			</VelavuSelect>
		</RulesEditorSection>
	);
}
